export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined") return;
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) {
    const standard = { Lead: true, ViewContent: true, InitiateCheckout: true };
    window.fbq(standard[name] ? "track" : "trackCustom", name, params);
  }
};
